export default {
  common: {
    querySpecifications: 'Query technical specifications',
    login: 'Sign In',
    logout: 'Sign Out',
    Home: 'Home',
    ProductCenter: 'Product Center',
    WhatIsaSoftwareDefinedCamera: 'What Is a Software-Defined Camera',
    ProductDetail: 'Product Detail',
    Solutions: 'Solutions',
    SolutionsDetail: 'Solutions Detail',
    Products: 'Products',
    Tools: 'Tools',
    Support: 'Support',
    Documentation: 'Documentation',
    news: 'News Center',
    newsDetail: 'News Detail',
    forPartners: 'For Partners',
    activity:'Activity',
    SoftwareDefinedCamera: 'Software-Defined Camera',
    IntelligentVisionSystem: 'IVS',
    Accessory: 'Accessory',
    ContactUs: 'Contact Us',
    NewsRoom: 'News Room',
    NewsRoomDetail: 'News Room Detail',
    Partner: 'Partner',
    Resources: 'Resources',
    ResourceCenter: 'Resource Center',
    VideoLibrary: 'Video Library',
    AftersalesSupport: 'Aftersales Support',
    Aftersales: 'Aftersales Q&A',
    Privacy: 'Privacy',
    TermsOfUse: 'Terms of use',
    clear:"Clear",
    RefineBy: 'Refine By',
    placeholder: 'Enter the model, name, or keyword',
    Favorites: 'Favorites',
    Compare: 'Compare',
    More: 'More',
    all: 'All',
    enter: 'Enter the model, name, or keyword',
    enterKeyword: 'Enter Keyword',
    resultsFound: 'Results Found',
    collapse: 'Collapse',
    expand: 'Expand',
    confirm:"Confirm",
    cancel:"Cancel",
    channel:"Channel",
    type: 'Type',
    submit: 'Submit',
    upload: 'Upload',
    activityHub: 'Activity Hub'
  },
  login: {
    title: 'Sign In with User ID',
    email: 'Email',
    pwd: 'Password',
    changePwd: 'Change Password',
    forgetPwd: 'Forget Password',
    register: 'Register',
    rulesEmail: 'Email is invalid',
  },
  //导航栏
  navbar: {
    aboutTitle: 'ABOUT',
    about: 'ABOUT HOLOWITS',
    products: 'PRODUCTS',
    productCenter: 'PRODUCT CENTER',
    technicalSupport: 'SUPPORT',
    FAQ:'FAQ',
    solution: 'SOLUTIONS',
    documentation: 'DOCUMENTATION',
    support: 'SUPPORT',
    certificate: 'Certificate',
    pocDemo: 'PoC Demo',
    news: 'NEWS ROOM',
    activityHub: 'ACTIVITY HUB', 
    events:'EVENTS',
    tools: 'TOOLS',
    partners: 'PARTNERS',
    resources: 'RESOURCES',
    forPartners: 'PARTNER DEVELOPMENT',
    forCustomers: 'FOR CUSTOMERS',
    channel:"PARTNER MAP",
    videoLibrary: "VIDEO",
    contact: "CONTACT US",
    // algorithmstore: "ALGORITHM STORE",
    algorithmstore: "ALGORITHM",
    terms: "POLICIES, TERMS, CONDITIONS",
    warrantypolicy: "WARRANTYPOLICY",
    firmware: "FIRMWARE",
    software: "SOFTWARE",
    becomeAPartner: 'BECOME A PARTNER',
    dealRegistration: 'Partner Deal Registration',
    training: 'e-Learning',
    knowledge: 'Knowledge',
    successfulCases: 'Success Stories'
  },
  home: {
    'whatIsNew': "What's New",
    'ProductSpotlight': 'Product Spotlight',
    'Events&News': 'Events & News',
    'learnMore': 'Learn More',
    'e-learning': 'E-learning',
    'certificate': 'Certificate',
    'video': 'Video',
    'wiki': 'Wiki'
  },
  //合作伙伴
  partners:{
    banner:{
      title:'HOLOWITS Certified',
      summery:'Intelligent Vision Specialist',
    },
    introduction:{
      title:'Introduction to Online Classes',
      desc:'This course introduces a full series of HOLOWITS software-defined cameras (SDCs), network video recorders (NVRs), intelligent Micro Edge devices, and solutions, and provides you with various learning materials and exams covering pre-sales and after-sales knowledge. You can obtain the certification of HOLOWITS Certified Intelligent Vision Specialist after passing the exams.',
    },
    course:{
      title:'Course Value',
      value:'This course will help you learn about the highlights of HOLOWITS product and solutions, master pre-sales skills, and provide customers with professional post-sales services.',
    },
    certification:{
      title:'Value of Certification',
      value:'This certificate can give you competitive edges in the market, showcase your expertise in HOLOWITS products, solutions, and after-sales services,and let customers and employers easily identify your professional capabilities.',
    },
    contents:[
      {text: 'HOLOWITS AI Camera Technical Presentation'},
      {text: 'HOLOWITS AI Video Platform Technical Presentation'},
      {text: 'HOLOWITS HWT-NVR800 Technical Main Slides'},
      {text: 'HOLOWITS iClient S100 Technical Training'},
      {text: 'HOLOWITS Accessory Configuration Guide'},
      {text: 'HOLOWITS Intelligent Retail Solution'},
      {text: 'HOLOWITS Intelligent Campus Solution'},
      {text: 'HOLOWITS Intelligent Grid Solution'},
      {text: 'HOLOWITS Intelligent Transportation Solution'},
      {text: 'HOLOWITS S200 Technical Training'},
      {text: 'Quick Guide to Target Capture Camera Site Survey and Commissioning'},
      {text: 'Quick Guide to ePolice Camera Site Survey and Commissioning'},
      {text: 'HOLOWITS HWT-NVR800 Installation and Commissioning'},
      {text: 'HOLOWITS HWT-IVS1800 Installation and Commissioning'},
      {text: 'HOLOWITS A series Camera and XVR Introduction'},
      {text: 'HOLOWITS APP Operation Manual'},
      {text: 'HOLOWITS E Series Camera Introduction'},
    ],
    learningGuide:{
      title:'Learning Guide',
      desc:'To pass the exams, you should meticulously study related materials and videos. After obtaining the certification, you must update the certificate every two years.',
      text:'Registration is required for the first login',
      registerCode:'Registration code: ',
      registerValue:'UJIQ-RVH-PQW',
      btnValue:'Start Exam',
    },
  },
  //关于Holowits
  aboutHWT:{
    label: {
      'Company Profile': 'Company Profile',
      'Who is HOLOWITS': 'Who is HOLOWITS',
      'HOLOWITS Offering': 'HOLOWITS Offering',
      'Business Overview': 'Business Overview',
      'Culture & Value': 'Culture & Value',
      'Quality Policy': 'Quality Policy',
      'Data Security': 'Data Security',
      'Cyber Security': 'Cyber Security',
      'Sustainable Development': 'Sustainable Development',
    },
    one: {
      wshtw: `Who is HOLOWITS`,
      ov: `Our Vision`,
      title1: `Everything sensing for an intelligent world`,
      title2: `About US`,
      content: `HOLOWITS is a global provider of intelligent Internet of Things (AIoT) products and solutions based on multi-dimensional awareness technologies, and integrates a broad range of capabilities such as R&D, production, distribution, sales and service capabilities. HOLOWITS is endowed with intelligent sensing technologies, a full-fledged industry chain, and powerful technical support capabilities. Responding to the ever-growing global demand for intelligence, HOLOWITS is committed to developing AI Camera (AIC), Video Intelligent Platform (VIP), as well as cloud services. These offerings can be applied in a wide variety of scenarios such as intelligent city, intelligent transportation, intelligent energy, intelligent manufacturing, intelligent campus, and intelligent retail. We aim to work together to build an intelligent world with all things sensing. To achieve this, we are devoted to providing safe, reliable, easy-to-use, and outstanding products and solutions for the global market.`
    },
    two: {
      content1: `HOLOWITS Offering`,
      content2: `Involving from IPC to AIC`,
      content3: `Software-defined Architecture, Transforming from "Feature camera" to "Smart camera"`,
      content4: `1960s Analog camera`,
      content5: `Optical and electromechanical`,
      content6: `1990s IP camera`,
      content7: `One camera for dedicated use`,
      content8: `2020s AI camera`,
      content9: `AI-powered Always-on intelligence`,
      content10: `Legacy cameras`,
      content11: `Limited computing power`,
      content12: `AI camera`,
      content13: `We firmly contend that the trajectory of AI camera technology bears a striking resemblance to the evolution from feature phones to smartphones. It is our considered opinion that this transformation, characterized by substantial advancements and revolutionary capabilities, is destined to propel the AI camera domain to new heights and fundamentally reshape the landscape of visual imaging.`,
      content14: `AI ROOT Technologies`,
      content15: `What makes HOLOWITS unique in the industry?`,
      content16: `In intelligent sensing field, HOLOWITS owns advanced AI root technologies.`,
      content17: `Products based on AI ROOT Technologies`,
      // content18: `SuperColor`,
      // content19: `Challenges`,
      // content20: `Light compensation is required under low-lit conditions`,
      // content21: `Traditional ISP optimization has reached the bottleneck`,
      // content22: `Interferences caused by rain and dust lead to poor-quality images`,
      // content23: `Crystal-clear night visioin with 0 light pollution`,
      content99: `With AI cameras and platform, HOLOWITS cooperates with partners to develop solutions of intelligent transportation, city, campus and retail for various customers, which helps achieve efficient management, service innovation, and business success. HOLOWITS continuously delivers products and services that help us build a world where all things can sense, making work and life easier and smarter.`
    },
    three: {
      content1: `Business Overview`,
      content2: `Business Map`,
      content3: `At HOLOWITS, we understand the importance of a strong and efficient distribution network. Our global reach is a testament to our commitment to making our innovative products accessible to customers around the world.`,
      content4: `Our distribution network spans across continents, with distributors strategically located in key markets worldwide. This extensive network allows us to deliver our products promptly and efficiently, ensuring that our customers receive the best service possible.`,
      content5: `Partners Wall`,
      content6: `HOLOWITS continuously working to expand and strengthen our distribution network. We are committed to reaching every corner of the globe, bringing our innovative, sustainable, and energy-efficient solutions to customers everywhere.
Whether you are a potential distributor interested in partnering with us, or a customer looking for our products, we invite you to join us in our journey towards creating a more intelligent and sustainable world.`,
    },
    four: {
      content1: `Culture & Value`,
      content2: `HOLOWITS strive to create a diverse and inclusive environment, as we firmly believe that creativity and innovation are fostered by embracing diversity.`,
      content3: `We welcome new perspectives and are committed to providing opportunities and support to individuals who embrace new challenges and strive to innovate.`,
      content4: `Working at HOLOWITS means being part of a dynamic team, collaborating closely to create and utilize cutting-edge technology. It is also a place for personal and professional growth, where you'll have ample opportunities to develop both as a skilled professional and as an individual.`,
    },
    five: {
      content1: `Quality Policy`,
      content2: `HOLOWITS are committed to delivering the highest quality products and services to our customers. Our quality assurance process is rigorous and comprehensive, ensuring that every product we deliver meets our high standards.`,
      content3: `We have adopted advanced quality management systems, inspired by leading global companies IBM. These systems guide our product development, production, and service processes, ensuring consistency and excellence at every stage.`,
      content4: `Our commitment to quality is further demonstrated by our adherence to international standards. We are proud to hold certifications in ISO9001 for quality management, ISO14000 for environmental management, ISO45000 for occupational health and safety, ISO20000 for IT service management, and ISO27000 for information security management. These certifications reflect our dedication to quality, safety, and sustainability.`,
      content5: `At HOLOWITS, quality is not just about meeting standards; it's about exceeding expectations. We continually strive to improve our products, services, and processes to deliver the best possible experience to our customers.`,
    },
    six: {
      content1: `Data Security`,
      content2: `At HOLOWITS, safeguarding your data isn't just a responsibility; it's our foremost commitment. Here's a deep dive into our comprehensive approach towards ensuring data security:`,
      content3: `Global Cloud Service Infrastructure: Our data centers aren't confined to a single region. We have established five primary cloud nodes across the world in Singapore, the UAE, Brazil, South Africa, and Ireland. This global presence doesn't just improve accessibility and efficiency; it also ensures data redundancy and recovery in the unforeseen event of a localized catastrophe.`,
      content4: `Designed for Protection: Our data centers are architectural masterpieces emphasizing user data protection. Each facility incorporates the latest advancements in physical security, environmental controls, and disaster preparedness. This solid foundation, coupled with our innovative software measures, makes our infrastructure one of the most secure in the industry.`,
      content5: `Legal Compliance and Beyond: While we strictly adhere to the laws and regulations of every country where our nodes are situated, we don't stop there. Our commitment to data security and privacy often goes above and beyond mere legal compliance. It's about earning and keeping our users' trust.`,
      content6: `Advanced Encryption Protocols: Encryption isn't an afterthought for us; it's a standard. We employ cutting-edge encryption methods, ensuring sensitive data remains shielded from unauthorized prying eyes, whether it's in transit or at rest.`,
      content7: `Proactive Threat Detection and Response: At HOLOWITS, we believe that the best defense is a good offense. Hence, our systems are constantly on the lookout for anomalies or potential threats. With our advanced threat detection capabilities, we're not just waiting to respond; we're actively identifying and neutralizing threats before they can manifest.`,
      content8: `24/7 Security Surveillance: Every minute of every day, our key data areas are under rigorous surveillance. Any unusual activity triggers our robust incident response protocol, guaranteeing swift action and minimizing potential impact.`,
      content9: `Continuous Improvement: In the dynamic world of cyber threats, resting on one's laurels is not an option. We're committed to an ongoing journey of enhancing our systems, processes, and techniques. Regular audits, penetration testing, and training sessions ensure that HOLOWITS remains at the pinnacle of data protection technology.`,
    },
    seven: {
      content1: `Sustainable Development`,
      content2: `At HOLOWITS, we are committed to sustainable development, a principle that is deeply ingrained in our business strategy and technological innovations. We believe in creating solutions that not only cater to the needs of our customers but also contribute positively to the environment.`,
      content3: `Our commitment to sustainability is reflected in our pioneering use of Artificial Intelligence (AI). We have harnessed the power of AI to develop products that are not only innovative but also environmentally friendly. Our core AI technologies - SuperColor, SuperCoding, SuperAI - are prime examples of this commitment.`,
      content4: `SuperColor technology allows our AI cameras to capture vibrant, full-color images without the need for additional illumination. This innovative approach reduces light pollution and conserves energy, contributing to a greener and more sustainable environment.`,
      content5: `SuperCoding, another key technology, optimizes video transmission and storage. It separates the video into foreground and background, applying normal coding to the dynamic foreground and depth coding to the background. This process reduces transmission bandwidth and storage needs by approximately 60%, resulting in significant energy savings.`,
      content6: `With SuperAI, Our AI camera's 1 TOPS computing power is equivalent to 2 TOPS in the industry, saving resources. At the same time, our open algorithm ecosystem allows the camera to freely switch algorithms. One AI camera can meet the demands that would otherwise require multiple cameras in the industry.`,
      content7: `From a company perspective, we aim to create solutions that are green and energy-efficient. Our Eco-Cube camera, for example, does not require network or power cables, reducing material usage and energy consumption. Furthermore, its design eliminates the need for extra human resources for device maintenance, further reducing our environmental footprint.`,
      content8: `At HOLOWITS, sustainable development is more than just a buzzword; it’s a guiding principle that shapes our business decisions and drives our innovation. We are dedicated to creating a future where technology and sustainability go hand in hand, contributing to a healthier planet and a brighter future for all.`,
    },
    eight: {
      content1: `Cyber Security`,
      content2: `HOLOWITS understands the importance of cyber security to customers and businesses and strictly complies with world-leading cyber security standards, especially the National Vulnerability Database (NVD) standards. HOLOWITS is committed to providing secure and reliable product solutions. In addition, HOLOWITS has advanced cyber security technologies and regards cyber security as the most important. Whenever HOLOWITS releases a new software version of a product, it scans for all possible vulnerabilities and fixes each detected vulnerability in a timely manner. Details about these fixes are stored in our official documentation to ensure transparency and traceability. To date, our products in the market do not have any vulnerabilities, because we have scanned and cleared all possible vulnerabilities before launching the products.`,
      content3: `HOLOWITS strictly complies with the NVD standards and fixes all vulnerabilities disclosed on the NVD website in a timely manner to ensure that its products do not have any of such vulnerabilities. This not only demonstrates our commitment to cyber security, but also shows that we attach great importance to customer cyber security. In summary, HOLOWITS always puts cyber security first. By using technological innovation and strict management measures, HOLOWITS ensures that its products and services can provide secure assurance for customers.`,
    }
  },
  // 产品中心
  products: {
    productTypes: 'Product Type',
    filters: {
        'All': 'All',
        'AI_Camera': 'AI Camera',
        'Video_Intelligent_Platform': 'Video Intelligent Platform',
        'IP_Camera_&_NVR': 'IP Camera & NVR',
        'Analog_Camera_&_XVR': 'Analog Camera & XVR',
        'Transmission': 'Transmission',
        'Display_&_Control': 'Display & Control',
        'Professional_Sound': 'Professional Sound',
        'Entrance_&_Exit_Management': 'Entrance & Exit Management',
        'Public_Address': 'Public Address',
        'Intelligent_Collaboration': 'Intelligent Collaboration',
        'Management_System': 'Management System',
        'Alarm': 'Alarm',
        'Accessories': 'Accessories',
        'HOLOWITS_Selected': 'HOLOWITS Selected',
        'HOLOWITS_Souvenir': 'HOLOWITS Souvenir',
        'Collapse': 'Collapse',
        'Expand': 'Expand '
    },
    sort: 'Sort',
    overAll: 'Overall',
    hot: 'Hot',
    latest: 'New',
    listPrice: 'List Price',
    preSales: 'Pre-Sales',
    model: 'Model',
    processor: 'Processor',
    memory: 'Memory',
    computingPower: 'Computing',
    Series: 'Series',
    Form: 'Form',
    More: 'More'
  },
  // 产品详情
  productDetail: {
    productDetail: 'Details',
    accessoryDetail: 'accessoryDetails',
    specifications: 'Specifications',
    certification: 'Certification',
    introduction: 'Introduction',
    download: 'Download',
    documentation: 'Documentation',
    huaweiCcsc: 'imgs/product_detail/mapen.png',
    clickHere: 'Click Here',
    dataSheet: 'Datasheet',
    afterSalesDocuments: 'After-Sales Documents',
    copy: 'Copy',
    reportError: 'Report Error',
    description: 'Description',
    describeError: 'Please describe the error you found.',
    picture: 'Picture',
    onlyJpg: 'Only the .jpg format is supported.',
    attachment: 'Attachment',
    selectFile: 'Select File',
    anonymous: 'Anonymous',
    submit: 'Submit',
    accessory: 'Accessory',
    technicalSpec: 'Technical Spec',
    dimensions: 'Dimensions',
    remarks: 'Remarks',
    optionalFitting: 'Optional Fitting',
    favorites: 'Favorite',
    keySpec: 'Key Spec',
    viewAll: 'Log In to View All',
    clicktoLoad: 'Download',
    completeSpecificationList: 'Complete Specification List',
  },
  // solutions
  solutions: {
    Industry: 'Industry',
    Region: 'Region',
    Type: 'Type',
    Solution: 'Solution',
    successStories: 'successStories',
    filters: {
      'Campus Sensing': 'Campus Sensing',
      'Transportation Sensing': 'Transportation Sensing',
      'City Sensing': 'City Sensing',
      'Africa': 'Africa',
      'Asian Pacific': 'Asian Pacific',
      'Europe': 'Europe',
      'Latin America': 'Latin America',
      'Middle East': 'Middle East',
      'Other': 'Other',
    }
  },
  // knowledge
  knowledge: {
    "Type": "Type",
    "All": "All",
    "HOLOWITS Academy": "HOLOWITS Academy",
    "Industrial Knowledge": "Industrial Knowledge",
    "HOLOWITS AIoT": "HOLOWITS AIoT",
    "Solution": "Solution"
  },
  // 技术支持
  support: {
    wahtDoYouNeedHelpWith: 'What do you need help with?',
    title: 'Welcome to HOLOWITS Technical Support',
    explain: 'HOLOWITS Technical Support provides first-class support for your HOLOWITS products and solutions. Our online support services and engineers around the world are ready to help you anytime, anywhere.',
    documentation: 'Documentation',
    softwareDownload: 'Software Download',
    video: 'Video',
    searchPlaceholder: 'Enter keyword',

    "HOLOWITS_Support": "HOLOWITS Support",
    "Wiki": "Wiki",
    "Firmware": "Firmware",
    "Software": "Software",
    "Knowledge": "Knowledge",
    "E-learning": "E-learning",
    "Policy,Terms": "Policy,Terms",
    "Announcement": "Announcement",
    "AI Camera": "AI Camera",
    "Video Intelligent Platform": "Video Intelligent Platform",
    "IP Camera & Analog Camera": "IP Camera & Analog Camera",
    "NVR & XVR": "NVR & XVR",
    "Software": "Software",
    "Cloud Service": "Cloud Service",
    "Solution": "Solution",
    "Other": "Other",
    "Tools": "Tools",
    "Calculate Bandwidth": "Calculate Bandwidth",
    "Calculate Recording Capacity": "Calculate Recording Capacity",
    "NVR Access": "NVR Access",
    "Calculate Cameras Detection Distance": "Calculate Camera's Detection Distance",
    "IP System Design Tool": "IP System Design Tool",
    "MD5 Checker": "MD5 Checker"
  },
  contact: {
    theme: 'Need Technical Support?',
    content: 'You are advised to contact the responsible HOLOWITS national distributor in your country or region for technical support.',
    tip1: 'To contact HOLOWITS distributors and resellers',
    tip2: 'To contact HOLOWITS for technical support, send emails to',
    tip3: 'To contact HOLOWITS for recruitment, send emails to',
    button1: 'Click here',
    button2: 'support@holowits.com',
    button3: 'hr@holowits.com',
    title: '',
    explain: '',
    tip4_1: 'Branch in Hong Kong: HOLOWITS TECHNOLOGIES HK LIMITED',
    tip4_2: 'Address: RM 1002,10/F EASEY COMM BLDG253-261 HENNESSY RD WAN CHAI HONG KONG',
    tip4_3: 'Email: support@holowits.com',
  },
    // 渠道中心
  channel: {
    partnerName: 'Partner Name',
    countryOrRegion: 'Country/Region',
    partnerType: 'PartnerType',
    searchPlaceholder:"Search in Partner List",
    website: 'Web Site',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    partners: {
      "Distributor": "Distributor",
      "Reseller": "Reseller",
      "System Integrator": "System Integrator",
      "All": "All",
      "Comprehensive Distributor": "Comprehensive Distributor",
      "Project-based Distributor": "Project-based Distributor",
      "Certified Service Partner": "Certified Service Partner",
      "Commercial Gold Partner": "Commercial Gold Partner",
      "Commercial Silver Partner": "Commercial Silver Partner",
      "Industry Gold Partner": "Industry Gold Partner",
      "Industry Silver Partner": "Industry Silver Partner",
    }
  },
  // 新闻中心
  news: {
    searchPlaceholder: 'Enter keyword',
    search: 'Search',
  },
  // 客户举办的活动
  activityHub: {
    title: 'ACTIVITY HUB',
    smallTitle: 'Partner Activities, Social Spotlights, and Community Moments'
  },
  // 安防工具
  securityTools: {
    cameradetectionDistance: 'Calculate Camera\'s Detection Distance',
    disable: 'Disable',
    enable: 'Enable',
    videoResolution: 'Video Resolution',
    encodingBitRate: 'Encoding Bit Rate',
    NumberOfNVRs: 'Number of NVRs',
    NumberOfSDCs: 'Number of SDCs',
    microCheckpoint: 'Micro checkpoint',
    ePoliceCheckpoint: 'ePolice/Checkpoint',
    targetDetection: 'Target detection/recognition',
    calculateBandwidth: 'Calculate Bandwidth',
    calculateRc: 'Calculate Recording Capacity',
    NVRAccess: 'NVR Access',
    ipTools: 'IP Video System Design Tool',
    md5: 'Md5Checker',
    //提示信息
    microResolutionTips: 'In micro checkpoint mode, it is recommended that the license plate resolution be at least 80 pixels.',
    microInstallationTips: 'In lane scenarios, it is recommended that the installation height range from 4.5 m to 6 m. At campus entrances and exits, it is recommended that the installation height range from 1.3 m to 1.5 m. You can set the installation height based on the site requirements.',
    ePoliceResolutionTips: 'In ePolice mode, the license plate resolution must be greater than or equal to 100 pixels. In checkpoint mode, if only license plates need to be captured, the license plate resolution must be greater than or equal to 100 pixels. If targets inside vehicles also need to be captured, the license plate resolution must be greater than or equal to 180 pixels. ',
    ePoliceInstallationTips: 'The recommended installation height ranges from 5.5 m to 6.5 m.',
    targetResolutionTips: 'Target detection: For short-focus (less than 12 mm) cameras, the recommended target resolution is at least 80 pixels. For medium- and long-focus (12 mm or more) cameras, the recommended target resolution is at least 120 pixels. Target recognition: For short-focus (less than 12 mm) cameras, the recommended target recognition is at least 110 pixels. For medium- and long-focus (12 mm or more) cameras, the recommended target resolution is at least 120 pixels.',
    targetInstallationTips: 'Target detection: For cameras with a fixed focal length of 2.8 mm or 3.6 mm, the recommended installation height ranges from 2 m to 2.5 m. For cameras with a fixed focal length of 6 mm, the recommended installation height ranges from 2 m to 3 m. For cameras with other focal lengths, the recommended installation height ranges from 2.5 m to 3.5 m. Target recognition: For short-focus cameras, the recommended installation height ranges from 2.5 m to 3 m. For long-focus cameras, the recommended installation height ranges from 2.5 m to 3.5 m.',
  },

  // 提示信息
  tipInfo: {
    exportFailure: 'Export failure.',
    addProToComp: 'Add the product to compare.',
    selectLeastTwo: 'Select at least two products for comparison.',
    selectMaximum: 'You can select a maximum of four products for comparison.',
    copySuccess: 'Copy success.',
    noData: 'No data.',
    selectOther: 'The selected device is no data. Please select another device.',
    onlyJpg: 'Only JPG images are supported.',
    exeNoUpload: 'EXE files cannot be uploaded.',
    problemNotEmpty: 'The problem description cannot be empty.',
    submitSuccess: 'Submitted successfully.',
    submitFailed: 'Submission failed. Try again later.',
    loginSuccess: 'Login success',
    errorPwd:'The two passwords are inconsistent',
    confirmLogout:'Confirm to exit the current account?',
    tooManyRequest:'Getting the authentication code is too frequent. Please try again in 3 minute',
    getCodeImageFailed:'Failed to get image verification code',
  },
  technologySupport: {
    support: 'Support',
  },
  // 文档中心
  documentation: {
    searchPlaceholder: 'Enter the keyword',
    search: 'Search',
    type: 'Type',
    productFilter: 'Product',
    solutionFilter: 'Solution',
    distributionFilter: 'Distribution',
    typeFilter: 'Scenarios',
    languageFilter: 'Language',
    formatFilter: 'Format',
    publishDate: 'Sort by release date',
    downloadTimes: 'Sort by download count',
    hotDoc: 'Hot Document',
    result: 'Result',
    download: 'Download',
    share: 'Share',
    batDownload: 'Batch Download',
    checkAll: 'Check All',
    paginalNumber: 'Paginal Number',
    loginTips: 'Login to get more materials',
    login: 'Login'
  },
  // 视频中心
  videoLibrary: {
    title: 'Video Library',
    searchVideo: 'Search video',
    all: 'All',
    branding: 'Branding',
    products: 'Products',
    solutions: 'Solutions',
    technicalSupport: 'Technical Support',
    training: 'Training',
    hOLOWITSClub: 'HOLOWITS Club',
    algorithm: 'Algorithm',
    technologies: 'Technologies'
  },
  faq: {
    faq: 'FAQ',
    Products: 'Products',
    Solutions: 'Solutions',
    Partners: 'Partners',
    Marketing: 'Marketing',
    Others: 'Others',
    placeholder: 'leave blank and you get all FAQs',
    help: 'How to use FAQ search'
  },
  learnRegister: {
    tips: "Tips",
    note: "Please note: Before applying for an exam account, please log in to your personal account in the top right corner.",
    noteOther: "Otherwise, your exam account application will not be submitted.",
    pageTitle: "HOLOWITS Certified Specialist Exam Registration",
    pageDesc1: "Please fill in the form below.",
    pageDesc2: "After verification, we will send email to you.",
    hint1: "Please prove that you are an employee of your company (You can upload your staff card or business card)",
    hint2: "Please upload your company business license (Not required)",
    required: "This field is required.",
    upload: "upload",
    successPanelTitle: "Submitted successfully",
    successPanelText: "The application has been submitted and the administrator will contact you via email.\nIf your company want to become our Certified Tier 2 partner, please click here to register. After one employee of your company passes HOLOWITS Certified Specialist Exam, your company can become our Certified Tier 2 partner and also can be shown our website.",
    inputPlaceholder: "Please briefly describe why you attend our HOLOWITS specialist exam"
  },
  register: {
    register: "Register",
    email: "Please input your Employee Email",
    companyName: "Company Full Name",
    name: "Your Name",
    country: "Country/Region",
    description: "Please describe the Partner Type of your company and HOLOWITS",
    code: "Verification Code",
    cancel: "Cancel",
    submit: "Submit",
    successPanelTitle: "Submitted successfully",
    successPanelText: "The application has been submitted and we will contact you via email.",
    back: "Back",
    rules: {
      email: "Email cannot be empty.",
      companyName: "Name cannot be empty.",
      name: "Name cannot be empty.",
      country: "CountryOrRegion cannot be empty.",
      description: "description cannot be empty.",
      code: "code cannot be empty."
    }
  },
  bind: {
    successPanelText: "The application has been submitted and we will contact you via email.",
  },
  reseller: {
    pageTitle: "BECOME A PARTNER",
    companyName: "Company Name",
    webSite: "Official Website URL",
    region: "Region",
    coopCountry: "Country/Region",
    preSales: "Email for Pre-sales support",
    postSales: "Email for Post-sales support",
    marketing: "Email for marketing support",
    email: "Email to contact you",
    companyEmail: "Email to be registered as your company account",
    phone: "Telephone Number for Pre-sales support",
    address: "Company Address",
    partnerType: "Partner Type",
    uploadLog: "Upload a high resolution graphic of your company logo (jpg. or png.)",
    upload: "Upload",
    downlaod: "Download agreement template",
    businessLicense: "Upload your company business license (File on larger than 50M) (Support pdf. png. jpg. jpeg. webp. format)",
    agreeFieldText: "I authorize HOLOWITS to list my company on HOLOWITS websites.",
    successPanelTitle: "Submitted successfully",
    successPanelText: "The application has been submitted and the administrator will contact you via email.",
    distributor: "Distributor",
    uploadTips: "Please download and print the file, fill in the relevant information and sign by hand, and then upload the scanned copy of the file.",
  },
  training: {
    documentation: "Documentation",
    "Scenario": "Scenario",
    "Pre-sales": "Pre-sales",
    "Post-sales": "Post-sales",
    "Product": "Product",
    "AI Camera": "AI Camera",
    "IP Camera/Analog Camera": "IP Camera/Analog Camera",
    "Video Intelligent Platform": "Video Intelligent Platform",
    "NVR/XVR": "NVR/XVR",
    "VMS": "VMS",
    "Accessories": "Accessories",
    "Other": "Other",
    "Solution": "Solution",
    "Intelligent Campus": "Intelligent Campus",
    "Intelligent City": "Intelligent City",
    "Intelligent Transportation": "Intelligent Transportation",
    "Intelligent Retail": "Intelligent Retail"
  },
  contactUs: {
    contactUsPricingInfo:'Contact Us Pricing Info',
    contactUs: 'Contact Us',
    options: {
      pricingInfo: 'Pricing/Info',
      serviceRequests: 'Service Requests',
    },
    pricingInfo: {
      Title: 'Contact Us',
      Desc1: 'Please fill in the form below.',
      Desc2: 'We will contact you soon.',
      Mandatory: 'Mandatory',
      FirstName: 'First Name',
      LastName: 'Last Name',
      Area: "Area",
      Email: 'Email',
      Telephone: 'Telephone',
      telephonePlaceholder: "Area Code-Number eg. 0066-123456",
      CountryRegion: 'Country/Region',
      Partner: 'Partner',
      PreferLanguage: 'Language',
      preference: 'Pleverye Select Language Preference',
      Company: 'Company',
      company_placeholder: 'Please input company full name',
      Industry: 'Industry',
      JobTitle: 'JobTitle',
      FavoriteProducts: 'FavoriteProducts',
      Budget: 'Budget',
      BrieflyPlaceholder: 'Briefly outline your project requirements. ',
      ConfirmText: 'I agree to receive information about products, solutions, services, and offerings from HOLOWITS and HOLOWITS authorized partners. I understand that I can unsubscribe at any time.',
      Yes: 'Yes',
      No: 'No',
      AgreeText: 'I understand and agree to the use and transfer of my personal information by HOLOWITS according to HOLOWITS’ ',
      PrivacyPolicy: 'Privacy Policy',
      publictiy: 'After one employee of your company passes HOLOWITS Certified Specialist Exam, your company can become our Certified Tier 2 Partner and also can be shown on our website.',
      TermsOfUse: 'Terms of Use',
      And: 'and',
      placeholder: 'Please input',
      submit: 'Submit',
      fieldRequired: 'This field is required.',
      emailValidator: {
        'at-error': 'An email address must contain a &quot;@&quot; symbol.',
        'account-letter-forbidden': 'The email name (example: Adam.Smith@abc.com) contains invalid characters.',
        'prevDot-error': 'The email name (example: Adam.Smith@abc.com) must not start or end with a dot or period (“.”).',
        'double-dot-error:': 'Two successive dots or periods (“.”) together is invalid.',
        'domain-error': 'The domain (example: Adam.Smith@abc.com) must contain at least one domain name.',
        'length-error': 'An email address must not exceed 254 characters.',
        'nextLetter-forbidden': 'The domain (example: Adam.Smith@abc.com) contains invalid characters.',
        'nextLine-error': 'The domain (example: Adam.Smith@abc.com) must not start or end with a hyphen (“-“).',
        'account-length-error': 'An email name (example: Adam.Smith@abc.com) must not exceed 63 characters.',
      },
      phoneFormatError: 'Example : Area Code(3-6 DIGITALS, eg.0066)Phone Number'
    },
  },
  algorithm: {
    // label: "ALGORITHM STORE",
    label: "ALGORITHM",
    // pageTitle: "HOLOWITS Algorithm Store",
    pageTitle: "HOLOWITS Algorithm",
    navOptionTag: "Intelligent Algorithm",
    recommendation: "Related products recommendation",
    rd: "Release Date",
    vud: "Version Update Date",
    selectorItemTitle: {
     "Product Application Scenario": "Product Application Scenario",
     "Algorithm Classification": "Algorithm Classification",
     "Applicable Platform": "Applicable Platform",
     "Algorithm type": "Algorithm type"
    },
    tag: {
     "All": "All",
     "Transportation": "Transportation",
     "Government": "Government",
     "Finance": "Finance",
     "Energy": "Energy",
     "Public Security": "Public Security",
     "Personnel Detection": "Personnel Detection",
     "Intelligent Transportation": "Intelligent Transportation",
     "Text Detection": "Text Detection",
     "Behavior Analysis": "Behavior Analysis",
     "Voice Detection": "Voice Detection",
     "Video Analysis": "Video Analysis",
     "Perimeter Events": "Perimeter Events",
     "Event Detection": "Event Detection",
     "Object Detection": "Object Detection",
     "Detection Analysis": "Detection Analysis",
     "SDC": "SDC",
     "HWT-IVS1800": "HWT-IVS1800",
     "HOLOWITS": "HOLOWITS",
     "HOLOWITS SELECTED": "HOLOWITS SELECTED",
     "OTHER": "OTHER"
    },
    label: {
     "Subway": "Subway",
     "Highway": "Highway",
     "Railway": "Railway",
     "Airport": "Airport",
     "Public Transport": "Public Transport",
     "Digital Government": "Digital Government",
     "Bank": "Bank",
     "Insurance": "Insurance",
     "Wind Power": "Wind Power",
     "Solar Energy": "Solar Energy",
     "Electric Power": "Electric Power",
     "Gas": "Gas",
     "Water Conservancy": "Water Conservancy",
     "Petroleum": "Petroleum",
     "Forest": "Forest",
     "City Management": "City Management",
     "Fire Detection": "Fire Detection",
     "Manufacturing": "Manufacturing",
     "Agriculture": "Agriculture",
     "Retail": "Retail",
     "Logistics": "Logistics",
     "Service": "Service",
     "Medical Treatment": "Medical Treatment",
     "Catering Industry": "Catering Industry",
     "Tourism": "Tourism",
     "Education": "Education",
     "Campus": "Campus",
     "Family": "Family",
     "Internet of Things(IoT)": "Internet of Things(IoT)",
     "Target Recognition": "Target Recognition",
     "Personnel Attribute Analysis": "Personnel Attribute Analysis",
     "Overall Target Detection": "Overall Target Detection",
     "License Plate detection": "License Plate detection",
     "Vehicle Attribute Detection": "Vehicle Attribute Detection",
     "Non-standard Vehicle Inspection": "Non-standard Vehicle Inspection",
     "Illegal Detection": "Illegal Detection",
     "Vehicle Detection": "Vehicle Detection",
     "Omni-data Structuring": "Omni-data Structuring",
     "OCR": "OCR",
     "Regulation Breach Detection": "Regulation Breach Detection",
     "Crowd Analysis": "Crowd Analysis",
     "Voice Synthesis": "Voice Synthesis",
     "Voice Identification": "Voice Identification",
     "Video Abstract": "Video Abstract",
     "Perimeter Intrusion": "Perimeter Intrusion",
     "Water Pollution Detection": "Water Pollution Detection",
     "Carrying Dangerous Objects": "Carrying Dangerous Objects",
     "Carrying Prohibited Items": "Carrying Prohibited Items",
     "Construction Machinery Detection": "Construction Machinery Detection",
     "Foreign Matter Detection": "Foreign Matter Detection",
     "Wearing Detection": "Wearing Detection",
     "Equipment Status Detection": "Equipment Status Detection",
     "Instrumentation Detection": "Instrumentation Detection",
     "Defect Detection": "Defect Detection",
     "Remote Sensing": "Remote Sensing",
     "Robot": "Robot",
     "X Series": "X Series",
     "M Series": "M Series",
     "C Series": "C Series",
     "D Series": "D Series",
     "HWT-IVS1800": "HWT-IVS1800",
     "Incidents Detection": "Incidents Detection",
     "HOLOWITS": "HOLOWITS",
     "HOLOWITS SELECTED": "HOLOWITS SELECTED",
     "OTHER": "OTHER",
     "Vehicle Detection": "Vehicle Detection",
     "Video Synopsis": "Video Synopsis",
    },
    details: {
      "update tips": "Not available, please wait for the update.",
      "Service Provider": "Service Provider",
      "To contact service provider": "To contact service provider",
      "Service Provider Profile": "Service Provider Profile",
      "tips": "Descriptions on the page are provided by service vendors based on their test results. Actual effects may vary depending on application scenarios. For details about comprehensive product capabilities, contact the store operation team.",
      "tags": {
        "Product Details": "Product Details",
        "Associated Product": "Associated Product",
        "Customer Case": "Customer Case",
        "Customer Evaluation": "Customer Evaluation",
        "Support": "Support"
      },
      smallTags: {
        "Parameters": "Parameters",
        "Introduction": "Introduction",
        "Version": "Version",
        "Highlights": "Highlights",
        "Scenario Requirements": "Scenario Requirements",
        "Graphic presentation": "Graphic presentation",
        "Solution with this algorithm": "Solution with this algorithm",
        "Supporting Applications": "Supporting Applications",
        "User Manual": "User Manual"
      }
    }
   },
   terms: {
    bigTitle: "Get familiar with the policies, terms, and conditions for the purchase, support, and servicing of HOLOWITS products.",
    title1: "Technical Support",
    title2: "HOLOWITS Product Warranty Policy",
    jumpPrompt: "Find the warranty policy",
  },
  announcement: {
    bigTitle: "Get familiar with the Announcement for the purchase, support, and servicing of HOLOWITS products.",
    title1: "Announcement",
  },
  specialist: {
    register: "Register",
    startLearning: "Start Learning"
  },
  csp: {
    title1: "Partner Type",
    title2: "Language", 
    all: "All",
    "Comprehensive Distributor": "Comprehensive Distributor",
    "Project-based Distributor": "Project-based Distributor",
    "Reseller": "Reseller",
    "System Integrator": "System Integrator",
    "Installer": "Installer"
  },
  tools: {
    cameras: "Cameras",
    codec: "Codec",
    scenario: "Scenario",
    videoResolution: "Video Resolution",
    frameRate: "Frame Rate",
    superCoding: "Super Coding",
    bitrate: "Bitrate(Kbps)",
    encodingBitRate: "Encoding Bit Rate (Mbit/s)",
    streamChannels: "Stream Channels",
    packetLossRate: "Packet Loss Rate",
    videoBufferingChannels: "Video Buffering Channels",
    singleImageSize: "Single Image Size",
    imagesUploadedPerSecond: "Images Uploaded Per Second",
    reservedBandwidthCoefficient: "Reserved Bandwidth Coefficient",
    uploadVia: "Upload via FTP/SFTP",
    disable: "Disable",
    enable: "Enable",
    calculate: "Calculate",
    reset: "Reset",
    calculateRecordingCapacity: "Calculate Recording Capacity ",
    basis: "Basis",
    basisVideo: "Video Resolution",
    basisiRate: "Encoding Bit Rate",
    encodingFormat: "Encoding Format",
    coefficient: "Bit rate fluctuation coefficient",
    storagePeriod: "Storage Period (Day)",
    result: "Result",
    forReferenceOnly: "for Reference Only",
    bandwidthRequired: "Bandwidth Required",
    about: "About",
    viewFormula: "View Formula",
    nvrAccess: "NVR Access",
    capacityRequired: "Capacity Required",
    calculationObject: "Calculation Object",
    obj1: "Number of NVRs",
    obj2: "Number of SDCs",
    model: "NVR Model",
    cameradetectionDistance: 'Calculate Camera\'s Detection Distance',
    microCheckpoint: "Micro checkpoint",
    ePolic: "ePolic/Checkpoint",
    recognition: "Target detection/recognition",
    resolutionRequirement: "Resolution Requirement (px)",
    sensorSize: "Sensor Size",
    resolution : "Resolution (w)",
    focal: "Focal Length (mm)",
    installationHeight: "Installation Height (m)",
    numberOfRrequired: "Number of required NVRs",
    numberOfAccessible: "Number of accessible SDCs",
    resultLabel1: "Detection Distance (d)",
    tilt: "Tilt Angle (α)",
    diagram: "Diagram",
    designTool: {
      title1: "IP Video System Design Tool",
      title2: "HOLOWITS cameras have been added into the database",
      title3: "With the IP Video System Design Tool you can:",
      small1: "Increase efficiency of security systems while lowering costs and finding the best camera locations.",
      small2: "Calculate precise camera lens and sensors requirements easily to achieve desired pixel density (PPM/PPF).",
      small3: "Visually show identification, recognition, observation, detection and monitoring zones of each camera on a site plan.",
      small4: "Import floor plans in JPEG, PNG, PDF, TIFF or AutoCAD DWG drawings (Pro) to jump start your designs.",
      small5: "Database of 10,000+ camera models, with pre-configured parameters for easy designing.",
      small6: "Estimate network bandwidth and storage needs for video archive configuration.",
      small7: "Plan cable paths and calculate cable lengths.",
      small8: "Export designs to include with proposals or work orders.",
      title4: "Click the link to download:",
      title5: "In order to update the camera database, please click ?/Check for new versions/Synchronize after installation."
    },
    md5: {
      title1: 'Md5Checker',
      introduce1: 'Md5Checker is a free, faster, lightweight and easy-to-use tool to manage, calculate and verify MD5 checksum of multiple files/folders. ',
      introduce2: 'You can use MD5Checker to verify the firmware you download on HOLOWITS website.',
      small1: 'Calculate and display MD5 checksum of multiple files at one time.',
      small2: 'Use MD5 checksum to fleetly verify whether files have been changed.',
      small3: 'Load, save, add, remove and update MD5 checksum conveniently.',
      small4: 'It is about 300 KB and does not require any installation (portable).',
      title2: 'What is MD5 checksum?',
      introduce3: 'MD5 checksum (MD5 hash) is a type of digests of files.',
      introduce4: 'different if any modification has been made to the file, even a byte.',
      downloadTips: 'Click the link to download:'
    }
  },
  firm: {
    label: "Firmware Download",
  },
  soft: {
    label: "Software Download",
  },
  newsRoom: {
    label: "NEWS ROOM",
    describe: "News and Announcements, Customer Wins, and More",
    learnMore: "LEARN MORE"
  },
  dr: {
    label: "DEAL REGISTRATION",
    subject: "Deal List",
    title: "Search Condition",
    state1: "Approved",
    state2: "Disapproved",
    state3: "To be Approved",
    state4: "Closed",
    state5: "Unclosed",
    state6: "Pending",
    state7: "Done",
    state8: "Cancelled",
    column1: "Project Name",
    column2: "Company Name (Applicant)",
    column3: "Expected Date of Order",
    column4: "Approval Status",
    column5: "Status",
    column6: "Expiration Date",
    column7: "End Customers Name"
  },
  drDetails: {
    subject1: "Deal Info",
    title1_1: "Deal Business Type",
    title1_2: "Project Name",
    title1_3: "Company Name (Applicant)",
    title1_4: "Win Odds (%)",
    title1_5: "Expected Date of Order",
    title1_6: "Public Tender",
    title1_7: "Deal Registration Start From",
    title1_8: "Expiration Date",
    title1_9: "Deal Description",
    title1_10: "Deal Background",
    title1_11: "Channel Manger Email",
    subject2: "Project Progress and Difficulties for help",
    title2_1: "Operation",
    title2_2: "Project Progress",
    title2_3: "Difficulties for help",
    title2_4: "Created Date",
    subject3: "Competitors",
    title3_1: "Operation",
    title3_2: "Competitor Name",
    title3_3: "Competitive Product",
    subject4: "Products",
    title4_1: "Operation",
    title4_2: "Product Type",
    title4_3: "Series",
    title4_4: "Model",
    title4_5: "Estimated Quantity",
    subject5: "Trading Parties",
    title5_1: "End Customers",
    title5_2: "Product Type",
    title5_3: "End Customers Name",
    title5_4: "End Custimer Name(Native)",
    title5_5_1: "First Name",
    title5_5_2: "Country/Region",
    title5_6: "Last Name",
    title5_7: "State",
    title5_8: "Email",
    title5_9: "City",
    title5_10: "Office Phone",
    title5_11: "Town",
    title5_12: "Address",
    title5_13: "Web site",
    title5_14: "Postal Code",
    title5_15: "Phone NO.",
    title5_16: "Industry",
    title5_17: "Sub-industry",
    title5_18: "Distributor",
    title5_19: "Company Name",
    title5_20: "Address",
    title5_21: "Location Name",
    title5_22: "Postal Code",
    title5_23: "City",
    title5_24: "Tier 2 Partner (if have)",
    title5_25: "Company Name",
    title5_26: "Address",
    title5_27: "Location Name",
    title5_28: "Postal Code",
    title5_29: "City",
    subject6: "Partner Sales Team",
    title6_1: "Operation",
    title6_2: "MAIN",
    title6_3: "Partner",
    title6_4: "Company Name",
    title6_5: "Role",
    title6_6: "Name",
    title6_7: "Email",
    title6_8: "Office phone",
    tips1_1: "1) For the purpose of HOLOWITS's provision of related services to you, HOLOWITS will collect Your personal data (including name, email, etc.), the personal data will be stored on the servers of HOLOWITS TECHNOLOGIES PTE. LTD. (HOLOWITS) and its affiliates. It may be processed by HOLOWITS and the relevant third party. It may be transferred to the third party's country/region or to locations separate from those where HOLOWITS collects the information, and will be accessed, stored, and processed in the aforesaid locations .For more details about how HOLOWITS processes the data, please see the Privacy Statement. Privacy Statement. ",
    tips1_2: "2) If the data you enter contains the personal information of a third party, please inform the third party of the above and obtain their consent or authorization, too. ",
    link1: "Privacy Statement.",
    tips2_1: "Request to close the deal",
    tips2_2: "(If you select this option, you will not be able to modify or update the content of this deal after it is closed).",
    submit: "Submit",
  }
};
